'use client'

import { useRef, useState } from 'react'
import { ResponsiveImage } from '@/components/home-ui'

interface AppView {
  label: string
  alt: string
  /** Nom de base de la capture dans `public/images/`. */
  image: string
}

/** Onglets Terrain / Direction du hero : bascule en fondu entre les deux captures de RISE. */
export default function AppViewsTabs({ label, views }: { label: string; views: AppView[] }) {
  const [selected, setSelected] = useState(0)
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([])

  function handleKeyDown(event: React.KeyboardEvent<HTMLButtonElement>, index: number) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return
    event.preventDefault()
    const next = (index + 1) % views.length
    setSelected(next)
    tabRefs.current[next]?.focus()
  }

  return (
    <>
      <div role="tablist" aria-label={label} style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginBottom: 'clamp(16px, 3vw, 36px)' }}>
        {views.map((view, index) => (
          <button
            key={view.image}
            ref={(element) => {
              tabRefs.current[index] = element
            }}
            type="button"
            role="tab"
            aria-selected={index === selected}
            onClick={() => setSelected(index)}
            onKeyDown={(event) => handleKeyDown(event, index)}
            style={{
              minHeight: '44px',
              padding: '0 22px',
              borderRadius: '999px',
              border: '0',
              cursor: 'pointer',
              fontFamily: 'inherit',
              fontSize: '15px',
              fontWeight: 700,
              color: '#0B0D10',
              transition: 'background-color 200ms ease',
              background: index === selected ? '#FFFFFF' : 'transparent',
            }}
          >
            {view.label}
          </button>
        ))}
      </div>
      <div style={{ display: 'grid' }}>
        {views.map((view, index) => (
          <ResponsiveImage
            key={view.image}
            className="heroshot"
            name={view.image}
            widths={[800, 1600]}
            width={1600}
            height={820}
            sizes="(max-width: 1600px) 100vw, 1600px"
            priority={index === 0}
            alt={view.alt}
            hidden={index !== selected}
            style={{
              gridArea: '1 / 1',
              display: 'block',
              width: '100%',
              height: 'auto',
              borderRadius: '12px 12px 0 0',
              border: '1px solid #C9DFE8',
              borderBottom: '0',
              boxShadow: '0 24px 64px rgba(11,13,16,0.10)',
              transition: 'opacity 400ms cubic-bezier(0.16,1,0.3,1)',
              opacity: index === selected ? 1 : 0,
            }}
          />
        ))}
      </div>
    </>
  )
}
